export const setSdkConfig = config => ({
    type: 'setSdkConfig',
    payload: config,
})
